    import moment from  'moment'

//--------------------------------------------------------------------------------------------------

  var globals = {
    version: 1.4,
    count: 23,
    database_loaded: false,
    authentication_checked: false,
    user: undefined,
    userData: undefined,
    db: {},
    show_beta_content: false,
	  skin: 2,
    small_spinner: false,
    big_spinner: false,
		db_loaded: { users:undefined, },
		off_canvas_menu_active: false,
		url: 'https://kia.milk-studio.dk/',
  }

	// try
  globals.skins = {
	  skin1: {
		  bgfadecolor1: 'red',
		  bgfadecolor2: 'blue',
	  },
	  skin2: {
		  bgfadecolor1: 'purple',
		  bgfadecolor2: 'yellow',
	  }
  }

//--------------------------------------------------------------------------------------------------

	globals.projectStatuses = {
		draft: { title:'Skitse' }, 
		//internal:{ title:'Internt' }, 
		//newbizz:{ title:'Newbizz' }, 
		active: { title:'Aktiv' }, 
		finished: { title:'Afsluttet' },
		aborted: { title:'Aflyst' },
	}  

//--------------------------------------------------------------------------------------------------

	globals.projects = {
		status_filter: 'active',
		search_filter: undefined,
	}

//--------------------------------------------------------------------------------------------------

	globals.clients = {
		search_filter: undefined,
	}	

//--------------------------------------------------------------------------------------------------

	// legacy:true betyder at man ikke længere kan logge på typen
	// MOVED TO VUEX STORE

  globals.worktypes = [

	{ value:'meeting', title:'Møde/dialog' },
    { value:'specs_offer', title:'Kravspec/tilbud' },

	{ value:'project_management', title:'Projektstyring' },
	{ value:'client_dialog', title:'Kundedialog', legacy: true },

	{ value:'graphic_design', title:'Grafisk design' },
	{ value:'development', title:'Udvikling' },
	{ value:'motiongraphics', title:'Motion graphics' },
    { value:'content', title:'Content' },
    { value:'testing', title:'Testing' },
	{ value:'maintenance', title:'Drift/support' },
    { value:'other', title:'Andet' },

  ]

//--------------------------------------------------------------------------------------------------

  globals.timelogger = {
    visible: false,
    addList: [],
    emptyListItem: { project_key:undefined, hours:0, task_key:undefined, worktype:undefined, title:undefined, date:moment().format('YYYY-MM-DD'), billable: true },
  }

//--------------------------------------------------------------------------------------------------

  globals.specs = {
    status_filter: 'all',
    search_filter: undefined,
  }

//--------------------------------------------------------------------------------------------------

	globals.spec = {
		changes: undefined,
		taskcats: undefined,
	}

//--------------------------------------------------------------------------------------------------

  globals.pieChartColors = ['#9FFFCB','#004E64','#00A5CF','#7AE582','#CDCDCD','#214E34','#E4959E','#CB9CF2','#9E7B9B','#F35B04','#7678ED']


//--------------------------------------------------------------------------------------------------

	globals.modal_timeline_project_popup = {
		active: false,
		project: undefined,
	}

//--------------------------------------------------------------------------------------------------

	globals.modal_timelog_edit = {
		active: false,
		timelog: undefined,
	}

//--------------------------------------------------------------------------------------------------

	globals.modal_economypost_edit = {
		active:false,
		economypost: undefined,
	}

//--------------------------------------------------------------------------------------------------

	globals.specelements = {

		newsletter_signup: {
			title: 'Nyhedsbrev signup',
			hours: 3,
		},

		search_function: {
			title: 'Søgefunktion',
			hours: 5,
		},

		analytics: {
			title: 'Analytics',
			no_pairing: [ 'analytics2' ],
			hours: 2,
		},

		analytics2: {
			title: 'Udvidet Analytics',
			no_pairing: [ 'analytics' ],
			hours: 5,
		},

		subpages1: {
			title: '1-5 unikke undersider',
			no_pairing: [ 'subpages2', 'subpages3', 'subpages4' ],
			hours: 3,
		},

		subpages2: {
			title: '6-10 unikke undersider',
			no_pairing: [ 'subpages1', 'subpages3', 'subpages4' ],
			hours: 5,
		},

		subpages3: {
			title: '11-20 unikke undersider',
			no_pairing: [ 'subpages1', 'subpages2', 'subpages4' ],
			hours: 7,
		},

		subpages4: {
			title: '20-40 unikke undersider',
			no_pairing: [ 'subpages1', 'subpages2', 'subpages3' ],
			hours: 10,
		},

		clientsize1: {
			title: 'Nystartet virksomhed',
			no_pairing: [ 'clientsize2', 'clientsize3', 'clientsize4' ],
			hours: 3,
		},

		clientsize2: {
			title: 'Mindre virksomhed',
			no_pairing: [ 'clientsize1', 'clientsize3', 'clientsize4' ],
			hours: 5,
		},

		clientsize3: {
			title: 'Mellem størrelse virksomhed',
			no_pairing: [ 'clientsize1', 'clientsize2', 'clientsize4' ],
			hours: 8,
		},

		clientsize4: {
			title: 'Stor virksomhed',
			no_pairing: [ 'clientsize1', 'clientsize2', 'clientsize3' ],
			hours: 15,
		},

		iosapp: {
			title: 'iOs Native App',
			hours: 30,
		},

		cookiewarning: {
			title: 'Cookie advarsel',
			hours: 3,
		},

		terms_text: {
			title: 'Terms tekst-side + popup',
			hours: 2,
		},

		correction1: {
			title: '1 retterunde',
			no_pairing: [ 'correction2' ],
			hours: 20,
		},

		correction2: {
			title: '2 retterunder',
			no_pairing: [ 'correction1' ],
			hours: 40,
		},

		testing1: {
			title: 'Testing S',
			no_pairing: [ 'testing2' ],
			hours: 40,
		},

		testing2: {
			title: 'Testing M',
			no_pairing: [ 'testing1' ],
			hours: 40,
		},

	}

//--------------------------------------------------------------------------------------------------

  window.globals = globals // console accesible, only for dev, but also used for indirectly related component state sharing
  export default globals



// WEBPACK FOOTER //
// ./src/globals.js